import React from 'react';
import ZLChart from './zlChart';
import './main.css';
import Typography from "@material-ui/core/Typography";

// Landing Pages Section 1D
function PageHeaderSection(props) {
    return (
        <section className="page-header-section">
            <div className="page-header-section__header">
                <Typography variant="h2">
                    {props.children}
                </Typography>
            </div>
            <ZLChart />
        </section>
    );
}

export default PageHeaderSection;